export default "__VITE_ASSET__DsscyT2c__"